
<script>
import moment from 'moment'
import { mixin as clickaway } from 'vue-clickaway'
import filtersField from '@/components/services/ui/filtersField.vue'
import { rexTagpicker } from '@/components/views/rexField'
import { rexRoundedDate } from '@/components/views/rexRoundedField'

export default {
  name: 'sale-filters',
  components: {
    rexTagpicker,
    filtersField,
    rexRoundedDate
  },
  mixins: [
    clickaway
  ],
  data: () => ({
    quickFilterButton: {
      isShow: false,
      offsetTop: 0,
    }
  }),
  computed: {
    isFilters() {
      return this.$store.getters['sale/isControls']
    },
    filtersCollection() {
      return this.$store.getters['sale/getFiltersCollection']
    },
    getDaysWithSales() {
      return this.filtersCollection.date.map(item => moment.unix(item).toDate())
    },
  },
  methods: {
    filter() {
      this.quickFilterButton = {
        isShow: false,
        offsetTop: 0
      }

      this.$store.commit('sale/updateIsFiltersApplied', true)
      this.$store.commit('sale/setIsLoading', true)
      this.$store.commit('sale/setCollection', [])

      this.$store.dispatch('sale/getCollection', {
        ...this.$store.getters['sale/getForm']
      })
    },
    getYesterdayDate() {
      return moment(new Date()).add(-1, 'days').toDate()
    },
    formChangeHandler({ element: { offsetTop } }) {
      this.quickFilterButton = {
        isShow: true,
        offsetTop
      }
    },
    hideQuickFilterButton() {
      this.quickFilterButton.isShow = false
    },
    openCreateForm() {
      this.$store.commit('sale/updateModalForm', {
        active: true,
        mode: 'new'
      })
    }
  }
}
</script>
<template>
  <div
    v-on-clickaway="hideQuickFilterButton"
    class="sale-filters rex-sidebar rex-sidebar--topped"
  >
    <a
      v-if="quickFilterButton.isShow"
      :style="{
        'top':`${quickFilterButton.offsetTop}px`
      }"
      href="javascript:;"
      class="rex-rounded-field--btn search-content__filters-quickfilter"
      @click="filter"
    >
      Применить
    </a>
    <b-loading
      v-if="!isFilters"
      :is-full-page="false"
      :active="!isFilters"
    />
    <div
      v-if="isFilters"
    >
      <filters-field
        label="Страна"
        :common-style="true"
      >
        <rex-tagpicker
          name="locations"
          store-module="sale"
          getter-name="getField"
          setter-name="setField"
          target="filters.locations"
          :data="filtersCollection.locations"
          @onChange="formChangeHandler"
        />
      </filters-field>
      <filters-field
        label="Дата заезда"
        :common-style="true"
      >
        <rex-rounded-date
          store-module="sale"
          getter-name="getField"
          setter-name="setField"
          target="filters"
          :min-date="getYesterdayDate()"
          placeholder=""
          :show-label="false"
          :range="true"
          position="is-bottom-left"
          range-start-date-name="dateFrom"
          range-end-date-name="dateTo"
          :marks="getDaysWithSales"
          @onChange="formChangeHandler"
        />
      </filters-field>
      <button
        class="rex-button rex-button--full-width rex-button--filled rex-button--filled-red"
        @click="filter"
      >
        Фильтровать
      </button>
      <button
        class="rex-button rex-button--full-width rex-button--glass rex-button--glass-red"
        @click="openCreateForm"
      >
        Создать
      </button>
    </div>
  </div>
</template>